import gql from "graphql-tag";
import ATTENDANCE_FRAGMENT from "@/graphql/fragments/attendance";

export default gql`
  query getAttendances($queueType: String!, $attendancePlaceId: ID, $employeeId: ID, $dayOfAttendance: String!) {
    attendances(
      queueType: $queueType
      attendancePlaceId: $attendancePlaceId
      employeeId: $employeeId
      dayOfAttendance: $dayOfAttendance
    ) {
      ...attendanceParts
      unit {
        id
        name
      }
    }
  }
  ${ATTENDANCE_FRAGMENT}
`;
